'use strict';

exports.__esModule = true;
exports.default = undefined;

var _class, _temp;

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _textures = require('textures');

var _textures2 = _interopRequireDefault(_textures);

var _selection = require('./selection');

var _selection2 = _interopRequireDefault(_selection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Circles = (_temp = _class = function (_Component) {
  _inherits(Circles, _Component);

  function Circles() {
    _classCallCheck(this, Circles);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Circles.prototype.render = function render() {
    var _this2 = this;

    var t = _textures2.default.circles();
    ['size', 'strokeWidth', 'stroke', 'fill', 'background', 'id', 'complement', 'radius'].forEach(function (key) {
      if (_this2.props[key]) t[key](_this2.props[key]);
    });
    var selection = new _selection2.default();
    t(selection);

    return selection.toReact(this.props.components);
  };

  return Circles;
}(_react.Component), _class.displayName = 'Circles', _class.defaultProps = {
  components: {
    defs: 'defs',
    g: 'g',
    circle: 'circle',
    rect: 'rect',
    pattern: 'pattern',
    path: 'path'
  }
}, _temp);
exports.default = Circles;
Circles.propTypes = process.env.NODE_ENV !== "production" ? {
  size: _propTypes2.default.number,
  strokeWidth: _propTypes2.default.number,
  stroke: _propTypes2.default.string,
  fill: _propTypes2.default.string,
  background: _propTypes2.default.string,
  id: _propTypes2.default.string,
  complement: _propTypes2.default.bool,
  radius: _propTypes2.default.number,
  components: _propTypes2.default.shape({
    defs: _propTypes2.default.node,
    g: _propTypes2.default.node,
    circle: _propTypes2.default.node,
    rect: _propTypes2.default.node,
    pattern: _propTypes2.default.node,
    path: _propTypes2.default.node
  })
} : {};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./packages/extra/node_modules/react-svg-textures/lib/Circles.js
// module id = 10
// module chunks = 0